import React from "react";
import HomeBackgroundImage from "../../assets/cta_bg.jpg";

const Cta = () => {

    const styleMainBg = {
        backgroundImage: `url(${HomeBackgroundImage})`
    };

    const styleCtaButton = {
        marginTop: "32px"
    };

    const viewLatestProduct = () => {
        window.location.href = "#latestProduct"
    };

    return (
        <div style={styleMainBg} className="cta-main-bg">
            <div className="cta-main-content">
                <h1 className="cta-title">Noble Notch</h1>
                <h3 className="cta-description">Big enough to deliver, small enough to care</h3>
                <button style={styleCtaButton} className="secondary-button" onClick={viewLatestProduct}>
                    View Latest Product
                </button>
            </div>
        </div>
    );
}

export default Cta